import React from 'react';
import PropTypes from 'prop-types';
import { TwitterPicker } from 'react-color';
import {
  Typography,
  IconButton,
  Icon,
} from '@material-ui/core';
import colors from '../../../utils/colors';

class ColorPicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = { displayColorPicker: false };
  }

  handleColorChange = (e) => {
    this.props.onColorChange(e);
    this.handleColorPickerClose();
  }

  handleColorPickerClose = () => {
    this.setState({ displayColorPicker: false });
  }

  handleColorPickerOpen = () => {
    this.setState({ displayColorPicker: true });
  }

  render() {
    const { color } = this.props;
    return (
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }}>
          <Typography variant="subtitle1" style={{ lineHeight: '48px' }}>
            Color
          </Typography>
        </div>
        <IconButton
          onClick={this.handleColorPickerOpen}
          color="inherit"
          style={{ color }}
        >
          <Icon>fiber_manual_record</Icon>
        </IconButton>
        {
          this.state.displayColorPicker
          && (
            <div
              style={{
                position: 'absolute',
                right: 0,
                zIndex: 10,
              }}
            >
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                }}
                onClick={this.handleColorPickerClose}
                onKeyDown={this.handleColorPickerClose}
                role="presentation"
              />
              <TwitterPicker
                color={color}
                colors={colors}
                onChange={this.handleColorChange}
              />
            </div>
          )
        }
      </div>
    );
  }
}

ColorPicker.propTypes = {
  color: PropTypes.string,
  onColorChange: PropTypes.func,
};

ColorPicker.defaultProps = {
  onColorChange: () => {},
  color: '',
};

export default ColorPicker;
